import axios from "axios";
import { url } from "./url.service";

const serverUrl = url + "/dashboard";

export const gteDashboardApi = (formData) => {
    return axios.get(serverUrl + "/");
};